import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './components/ProtectedRoute';
import ConsoleLayout from './components/layout/ConsoleLayout';
import Landing from './pages/Landing';
import LoginRedirect from './pages/LoginRedirect';
import AuthCallback from './pages/AuthCallback';
import Models from './pages/Models';
import CompareModels from './pages/CompareModels';
import Playground from './pages/Playground';
import ApiKeys from './pages/ApiKeys';
import Usage from './pages/Usage';
import Docs from './pages/Docs';
import AdvisorFab from './components/AdvisorFab';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/inference">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginRedirect />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/console"
            element={
              <ProtectedRoute>
                <ConsoleLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="models" replace />} />
            <Route path="models" element={<Models />} />
            <Route path="models/compare" element={<CompareModels />} />
            <Route path="playground" element={<Playground />} />
            <Route path="keys" element={<ApiKeys />} />
            <Route path="usage" element={<Usage />} />
            <Route path="docs" element={<Docs />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <AdvisorFab />
      <Toaster
        position="top-right"
        toastOptions={{ style: { background: '#1A1A24', color: '#EDEDF0', border: '1px solid #34343F', fontSize: 13 } }}
      />
    </QueryClientProvider>
  );
}

export default App;
